import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section id="accueil" className="relative w-full h-[720px] md:h-[820px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Massive%20orange%20container%20cargo%20ship%20sailing%20on%20deep%20blue%20ocean%20at%20golden%20hour%2C%20dramatic%20cinematic%20lighting%2C%20aerial%20view%20of%20international%20shipping%20vessel%20loaded%20with%20colorful%20containers%2C%20misty%20horizon%2C%20powerful%20maritime%20industrial%20scene%2C%20editorial%20photography%2C%20high%20detail%20professional%20logistics%20imagery&width=1800&height=1000&seq=gls-hero-01&orientation=landscape"
        alt="Sea freight"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/80"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-10 pt-20">
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/40 text-primary-200 text-xs md:text-sm font-medium tracking-wide uppercase mb-6">
            <i className="ri-ship-line w-4 h-4 flex items-center justify-center"></i>
            Commissionnaire de transport international
          </span>
          <h1 className="font-heading text-white text-4xl md:text-6xl lg:text-7xl font-bold leading-tight max-w-5xl">
            Nous connectons les continents<br/>
            <span className="text-primary-400">par la mer.</span>
          </h1>
          <p className="mt-6 text-base md:text-xl text-white/85 max-w-3xl mx-auto leading-relaxed">
            Godwin Logistics simplifie la complexité du commerce mondial. Fret maritime FCL, LCL, projets hors gabarit et gestion douanière depuis nos hubs stratégiques en Chine.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact" className="px-8 py-3.5 rounded-md bg-primary-500 hover:bg-primary-600 text-white font-semibold whitespace-nowrap cursor-pointer transition inline-flex items-center gap-2">
              Obtenir un devis gratuit <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
            <Link to="/solutions" className="px-8 py-3.5 rounded-md bg-white/10 hover:bg-white/20 backdrop-blur border border-white/30 text-white font-semibold whitespace-nowrap cursor-pointer transition">
              Nos solutions
            </Link>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 bg-background-950/40 backdrop-blur-sm border-t border-white/10">
          <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 px-6 py-6 text-white">
            {[
              { n: '10+', l: "Années d'expertise" },
              { n: '2 000+', l: 'Clients servis' },
              { n: '1 000+', l: 'Conteneurs traités' },
              { n: '24/7', l: 'Suivi & support' },
            ].map((s, i) => (
              <div key={i} className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-400">{s.n}</div>
                <div className="text-xs md:text-sm text-white/80 mt-1">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}